import { generatePath } from "react-router";

/**
 * Rutas del frontal (en inglés; los textos van por i18n). Las de la API van
 * aparte (`/v1/...`). Producción: https://firma.punto.ai; desarrollo y staging:
 * https://firma.dev.punto.ai.
 *
 * Los filtros de las listas (Actividad, sobre todo) van en la query string para
 * poder compartir una búsqueda.
 */
export const paths = {
  // Fuera del shell
  login: "/login",
  selectOrganization: "/select-organization",
  noAccess: "/no-access",
  /** Autorizar la app de Mac (flujo OAuth PKCE que abre ASWebAuthenticationSession). */
  connectMac: "/connect-mac",

  // Organización
  home: "/",
  certificates: "/certificates",
  certificateNew: "/certificates/new",
  certificate: "/certificates/:id",
  certificateOverview: "/certificates/:id/overview",
  certificateVersions: "/certificates/:id/versions",
  certificateAccess: "/certificates/:id/access",
  certificateActivity: "/certificates/:id/activity",
  certificateReplace: "/certificates/:id/replace",
  policies: "/policies",
  policyNew: "/policies/new",
  policy: "/policies/:id",
  people: "/people",
  person: "/people/:id",
  groups: "/people/groups",
  group: "/people/groups/:id",
  activity: "/activity",
  activitySignatures: "/activity/signatures",
  activityNavigation: "/activity/navigation",
  activityAdmin: "/activity/admin",
  organization: "/organization",
  myCertificates: "/my/certificates",
  myActivity: "/my/activity",

  // Plataforma (Punto)
  platform: "/platform",
  platformOrganizations: "/platform/organizations",
  platformSupport: "/platform/support",
  platformCatalog: "/platform/catalog",
} as const;

/** `to(paths.certificateVersions, { id })` → `/certificates/abc/versions`. */
export const to = generatePath;

/** Navegación de página entera: la gestiona `api` (OIDC con Google). */
export const GOOGLE_LOGIN_URL = "/v1/auth/google/login";
